import React, { useCallback, useState } from "react";
import makeStyles from "@mui/styles/makeStyles";

import Container from "@mui/material/Container";
import CollectionBrowser from "./browse/CollectionBrowser";
import CollectionNew from "./edit/CollectionNew";
import { Route, Routes, useNavigate } from "react-router-dom";
import { useSearch } from "../searchServices";
import RequireRoles from "../../auth/RequireRoles";
import CollectionEdit from "./edit/CollectionEdit";
import { creatorRoles } from "../../auth/authUtils";

const useStyles = makeStyles(theme => ({
  panel: {
    display: "flex",
    flexDirection: "column",
    height: "95%",
    padding: "0",
    border: "3px solid white",
    background: "white",
    borderRadius: "20px",
  },
}));

const initialSearchState = {
  appliedQuery: [],
  appliedFacets: [
    {
      name: "type",
      queryParam: "_type",
      terms: [
        {
          code: "COLLECTION",
        },
      ],
    },
    {
      name: "status",
      queryParam: "status",
      terms: [{ code: "(-status:* AND *:*)" }, { code: "status:*" }],
    },
  ],
  orderBy: null,
  orderDirection: "asc",
  appliedPublicationYearGroups: [],
  page: 0,
  noFacets: true,
};

const CollectionView = () => {
  const classes = useStyles();
  const navigate = useNavigate();

  const [searchState, setSearchState] = useState(initialSearchState);

  const searchResults = useSearch(searchState);

  const handleSave = useCallback(() => {
    searchResults.refetch();
    navigate(-1);
  }, [searchResults, navigate]);

  const handleCancel = useCallback(() => {
    navigate(-1);
  }, [navigate]);

  return (
    <Container
      id="collection-view"
      maxWidth={false}
      classes={{ root: classes.panel }}
    >
      <Routes>
        <Route
          index
          element={
            <RequireRoles roles={creatorRoles} showUnauthorized={false}>
              <CollectionBrowser
                searchState={searchState}
                onSearchStateChange={state => setSearchState(state)}
                searchResults={searchResults}
                onSaveSuccess={handleSave}
              />
            </RequireRoles>
          }
        />
        <Route
          path="new/*"
          element={
            <RequireRoles roles={creatorRoles} showUnauthorized={false}>
              <CollectionNew
                onCancel={() => navigate("/creator/collections")}
              />
            </RequireRoles>
          }
        />
        <Route
          path=":id/*"
          element={
            <RequireRoles roles={creatorRoles} showUnauthorized={false}>
              <CollectionEdit onCancel={handleCancel} />
            </RequireRoles>
          }
        />
      </Routes>
    </Container>
  );
};

export default CollectionView;
